import { Chip, SxProps, Theme } from '@mui/material';
import {
  Park,
  Nature,
  EnergySavingsLeaf,
  SetMeal,
  LocalFireDepartment,
} from '@mui/icons-material';
import { CarbonRating } from '../types';

const carbonColor: Record<CarbonRating, string> = {
  [CarbonRating.A]: '#2e7d32',
  [CarbonRating.B]: '#558b2f',
  [CarbonRating.C]: '#f9a825',
  [CarbonRating.D]: '#ef6c00',
  [CarbonRating.E]: '#c62828',
};

const carbonIcon: Record<CarbonRating, typeof Park> = {
  [CarbonRating.A]: Park,
  [CarbonRating.B]: Nature,
  [CarbonRating.C]: EnergySavingsLeaf,
  [CarbonRating.D]: SetMeal,
  [CarbonRating.E]: LocalFireDepartment,
};

interface CarbonRatingChipProps {
  rating: CarbonRating;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

const CarbonRatingChip = ({ rating, size = 'small', sx }: CarbonRatingChipProps) => {
  const Icon = carbonIcon[rating];
  return (
    <Chip
      icon={<Icon sx={{ color: '#fff !important', fontSize: size === 'small' ? 16 : 20 }} />}
      label={`CO₂ ${rating}`}
      size={size}
      sx={{
        backgroundColor: carbonColor[rating],
        color: '#fff',
        fontWeight: 700,
        '& .MuiChip-icon': {
          color: '#fff',
        },
        ...((sx as object) ?? {}),
      }}
    />
  );
};

export default CarbonRatingChip;
